import { Component, OnInit, Input } from '@angular/core';

import { ViewCell } from '@app/shared/smart-table/ng2-smart-table';
import { StationService } from '@app/core/station.service';
import { ModuloService } from '@app/core/modulo.service';

@Component({
  standalone: false,
  selector: 'app-module-power-supply',
  template: `
    {{ renderValue }}
  `
})
export class ModulePowerSupplyComponent implements OnInit, ViewCell {
  @Input() value: string;
  @Input() rowData: any;

  public renderValue: string;
  modulePowerSupplyTypes = this.moduleService.modulePowerSupplyTypes;

  constructor(private moduleService: ModuloService) {}

  ngOnInit() {
    if (this.modulePowerSupplyTypes) {
      const index = this.modulePowerSupplyTypes.findIndex(
        s => s.value === this.value
      );
      if (index !== -1) {
        this.renderValue = this.modulePowerSupplyTypes[index].name;
      }
    }
  }
}
